export const initialLayout = {
  lg: [
    { w: 3, h: 1, x: 0, y: 0, i: "kpi1" },
    { w: 3, h: 1, x: 3, y: 0, i: "kpi2" },
    { w: 3, h: 1, x: 6, y: 0, i: "kpi3" },
    { w: 3, h: 1, x: 9, y: 0, i: "kpi4" },
    { w: 3, h: 1, x: 0, y: 1, i: "kpi5" },
    { w: 3, h: 1, x: 3, y: 1, i: "kpi6" },
    { w: 3, h: 1, x: 6, y: 1, i: "kpi7" },
    { w: 3, h: 1, x: 9, y: 1, i: "kpi8" },
    { w: 6, h: 3, x: 0, y: 1, i: "chart1" },
    { w: 6, h: 3, x: 6, y: 1, i: "chart2" },
    { w: 12, h: 4, x: 0, y: 4, i: "table1" },
  ],
  md: [
    { w: 5, h: 1, x: 0, y: 0, i: "kpi1" },
    { w: 5, h: 1, x: 5, y: 0, i: "kpi2" },
    { w: 5, h: 1, x: 0, y: 1, i: "kpi3" },
    { w: 5, h: 1, x: 5, y: 1, i: "kpi4" },
    { w: 10, h: 1, x: 0, y: 2, i: "kpi5" },
    { w: 10, h: 1, x: 5, y: 2, i: "kpi6" },
    { w: 10, h: 1, x: 0, y: 2, i: "kpi7" },
    { w: 10, h: 1, x: 5, y: 2, i: "kpi8" },
    { w: 10, h: 3, x: 0, y: 3, i: "chart1" },
    { w: 10, h: 3, x: 0, y: 6, i: "chart2" },
    { w: 10, h: 4, x: 0, y: 9, i: "table1" },
  ],
  sm: [
    { w: 4, h: 1, x: 0, y: 0, i: "kpi1" },
    { w: 4, h: 1, x: 4, y: 0, i: "kpi2" },
    { w: 4, h: 1, x: 0, y: 1, i: "kpi3" },
    { w: 4, h: 1, x: 4, y: 1, i: "kpi4" },
    { w: 8, h: 1, x: 0, y: 2, i: "kpi5" },
    { w: 8, h: 1, x: 4, y: 2, i: "kpi6" },
    { w: 8, h: 1, x: 0, y: 2, i: "kpi7" },
    { w: 8, h: 1, x: 4, y: 2, i: "kpi8" },
    { w: 8, h: 3, x: 0, y: 3, i: "chart1" },
    { w: 8, h: 3, x: 0, y: 6, i: "chart2" },
    { w: 8, h: 4, x: 0, y: 9, i: "table1" },
  ],
  xs: [
    { w: 4, h: 1, x: 0, y: 0, i: "kpi1" },
    { w: 4, h: 1, x: 0, y: 1, i: "kpi2" },
    { w: 4, h: 1, x: 0, y: 2, i: "kpi3" },
    { w: 4, h: 1, x: 0, y: 3, i: "kpi4" },
    { w: 4, h: 1, x: 0, y: 4, i: "kpi5" },
    { w: 4, h: 1, x: 0, y: 4, i: "kpi6" },
    { w: 4, h: 1, x: 0, y: 4, i: "kpi7" },
    { w: 4, h: 1, x: 0, y: 4, i: "kpi8" },
    { w: 4, h: 3, x: 0, y: 5, i: "chart1" },
    { w: 4, h: 3, x: 0, y: 8, i: "chart2" },
    { w: 4, h: 4, x: 0, y: 11, i: "table1" },
  ],
  xxs: [
    { w: 2, h: 1, x: 0, y: 0, i: "kpi1" },
    { w: 2, h: 1, x: 0, y: 1, i: "kpi2" },
    { w: 2, h: 1, x: 0, y: 2, i: "kpi3" },
    { w: 2, h: 1, x: 0, y: 3, i: "kpi4" },
    { w: 2, h: 1, x: 0, y: 4, i: "kpi5" },
    { w: 2, h: 1, x: 0, y: 4, i: "kpi6" },
    { w: 2, h: 1, x: 0, y: 4, i: "kpi7" },
    { w: 2, h: 1, x: 0, y: 4, i: "kpi8" },
    { w: 2, h: 3, x: 0, y: 5, i: "chart1" },
    { w: 2, h: 3, x: 0, y: 8, i: "chart2" },
    { w: 2, h: 4, x: 0, y: 11, i: "table1" },
  ],
};
